import { Group, Text, Title } from '@mantine/core';
import { ReactNode } from 'react';
import { HelpPopover } from 'src/design/molecules/HelpPopover';
import {
  PageBreadcrumbs,
  IPageBreadcrumbsProps,
} from 'src/design/molecules/PageBreadcrumbs';

export interface IHeaderProps {
  breadcrumbProps: IPageBreadcrumbsProps;
  title: string;
  subtitle?: string;
  helpTitle?: string;
  helpText: string;
  actions?: ReactNode;
}

/** @registry Standard page header: Breadcrumbs + title + HelpPopover + optional subtitle and right-aligned actions; use at the top of route pages instead of hand-rolling the layout. */
export const Header: React.FC<IHeaderProps> = ({
  breadcrumbProps,
  title,
  subtitle,
  helpText,
  helpTitle,
  actions,
}) => {
  return (
    <>
      <PageBreadcrumbs {...breadcrumbProps} />
      <Group mb="md" justify="space-between">
        <Group>
          <Title order={2}>{title}</Title>
          <HelpPopover title={helpTitle ?? title} text={helpText} />
        </Group>
        {actions && <Group>{actions}</Group>}
      </Group>
      {subtitle && <Text mb="md">{subtitle}</Text>}
    </>
  );
};
